import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StartseiteComponent } from './startseite/startseite.component';
import { ImprintComponent } from './imprint/imprint.component';
import { DataPrivacyComponent } from './dataprivacy/dataprivacy.component';
import { ContactComponent } from './contact/contact.component';
import { VitaComponent } from './vita/vita.component';
import { GaleryComponent } from './galery/galery.component';

const routes: Routes = [
  {
    path: '',
    component: StartseiteComponent
  }
  , {
    path: 'imprint',
    component: ImprintComponent
  }
  , {
    path: 'contact',
    component: ContactComponent
  }
  , {
    path: 'vita',
    component: VitaComponent
  }
  , {
    path: 'dataprivacy',
    component: DataPrivacyComponent
  }
  , {
    path: 'art-projects/:project',
    component: GaleryComponent
  },
  {
    path: 'exhibition/:project',
    component: GaleryComponent
  }

  ,{path: '**', redirectTo: '/'}

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
